import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordRegexValidator(): ValidatorFn {
  const cognitoPasswordRegex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-\"!@#%&\/,><\':;|_~`])\S{8,99}$/);

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value && !cognitoPasswordRegex.test(value)) {
      return { invalidPassword: true };
    }
    return null;
  };
}
